import { NextPage } from 'next';
import ErrorBoundary from '../../../../../../components/ErrorBoundary';
import config from '../../../../../../config';
import ErrorPage from '../../../../../../containers/ErrorPage';
import Spot from '../../../../../../containers/Spot';
import { getOrCreateStore } from '../../../../../../stores';

const SpotPage: NextPage = (props: any) => {
  const {
    page: { payloadStatus },
  } = props;

  const pageContent = () => {
    if (payloadStatus !== 200) {
      return <ErrorPage statusCode={payloadStatus} />;
    }
    return <Spot {...props} />;
  };

  return (
    <ErrorBoundary error={payloadStatus === 500} errorBoundaryId="spot-page">
      {pageContent()}
    </ErrorBoundary>
  );
};

SpotPage.getInitialProps = async (context) => {
  const { id } = context.query;

  const { getState } = getOrCreateStore();

  const isServer = !!context.req;

  const url = `${config.servicesURL}/travel/zones/spot?id=${id}`;
  const result = await fetch(url);
  const { spot, status } = await result.json();
  const { statusCode } = status;

  if (isServer) {
    const newrelic = require('newrelic');
    newrelic.addCustomAttributes({
      id,
    });
    return {
      enableTheme: true,
      enableCssBaseline: true,
      ssrReduxState: getState(),
      page: {
        spot,
        payloadStatus: statusCode,
      },
    };
  }

  return {
    enableTheme: true,
    enableCssBaseline: true,
    page: {
      spot,
      payloadStatus: statusCode,
    },
  };
};

export default SpotPage;
